// ProgressBar — determinate horizontal progress (e.g. IRS-limit usage, goal
// progress). Tone colors the fill; value is 0–100.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import './progress-bar.css';

export function ProgressBar({ value = 0, tone = 'primary', height = 8, showLabel = false, className }) {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div className={cx('progress-bar', className)}>
      <div
        className="progress-bar__track"
        style={{ height }}
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div className={cx('progress-bar__fill', `progress-bar__fill--${tone}`)} style={{ width: `${pct}%` }} />
      </div>
      {showLabel && <span className="progress-bar__label">{Math.round(pct)}%</span>}
    </div>
  );
}

ProgressBar.propTypes = {
  value: PropTypes.number,
  tone: PropTypes.oneOf(['primary', 'success', 'warning', 'danger', 'purple']),
  height: PropTypes.number,
  showLabel: PropTypes.bool,
  className: PropTypes.string,
};

export default ProgressBar;
